import { createContext, useContext, useState } from 'react';
import { readUrlState } from '../utils/deepLink';

// Global dashboard month filter.
// '' means "latest available" — views resolve it via meta.latestMonth so the
// dashboard always opens on the newest month without waiting for metadata here.
const MonthContext = createContext(null);

export function MonthProvider({ children }) {
  const [month, setMonth] = useState(() => readUrlState().month);

  return (
    <MonthContext.Provider value={{ month, setMonth }}>
      {children}
    </MonthContext.Provider>
  );
}

export const useMonth = () => useContext(MonthContext);
